/* auth.js */

import { user, token, states, filters, bindings } from '@/stores';
import { websocket } from '@/helpers/websocket';
import { validate } from '@/helpers/validate';
import { push as notificationPush } from '@/helpers/notifications';


const MODELS = {
	token: {
		_token: {
			required: true,
			type: 'string',
			mask: /^[0-9A-Fa-f]{64}$/,
		},
		_time: {
			required: true,
			type: 'int',
		},
	},
	user: {
		_user: {
			required: true,
			type: 'object',
			model: {
				id: {
					required: true,
					type: 'int',
				},
				name: {
					required: true,
					type: 'string',
					empty: true,
				},
				card_id: {
					required: true,
					type: 'int',
					null: true,
				},
				permissions: {
					required: true,
					type: 'array',
					empty: true,
				},
				card_name: {
					type: 'string',
					empty: true,
				},
				manager_name: {
					type: 'string',
					empty: true,
					null: true,
				},
				manager_phone: {
					type: 'string',
					empty: true,
					null: true,
				},
				states: {
					type: 'dict',
					null: true,
				},
			},
			strict: true,
		},		
	},
};


/* init */
export function init() {
	const storage = states.pull('storage');
	if (storage) {
		token.load();
		user.load();
	}
	
	websocket.on('connect',
		() => {
			states.push({
				connect: true,
				websocket: websocket,
			});
			token.load();
			websocket.send(
				JSON.stringify({
					command: 'register',
					token: token.pull('token'),
					user_id: user.pull('id'),
				})
			);
		}
	);
	websocket.on('disconnect',
		() => {
			states.push({
				connect: false,
				websocket: null,
			});
		}
	);
	websocket.on('message',
		message => {
			const data = JSON.parse(message);
			if (data.event)
				notificationPush('events', data.title, [ 'websocket', data ]);
			if (data.notification)
				notificationPush('notifications', data.notification, [ 'websocket', data ]);
		}
	);
}


/* auth */
export function auth(data) {
	token.load();
	const storage = states.pull('storage');
	const timeStamp = token.pull('time');
	if (validate(data, MODELS.token)) {
		if (data._time > timeStamp) {
			token.push({
				token: data._token,
				time: data._time,
			});
			token.save();
		}
		if (validate(data, MODELS.user)) {
			const user_id = user.pull('id');
			user.push(data._user);
			user.save();
			checkWebsocketConnection(user_id, data._user.id);
		}
	}
}


/* checkWebsocketConnection */
function checkWebsocketConnection(fromUserId, toUserId) {
	const conn = websocket.isEstablished();
	if (toUserId) {
		if (fromUserId !== toUserId) {
			if (conn) {
				websocket.disband();
				websocket.on('disconnect', websocket.establish.bind(websocket), true);
			}
			else {
				websocket.establish();
			}
		}
		else {
			if (!conn)
				websocket.establish();
		}
	}
	else {
		if (conn)
			websocket.disband();
	}
}


/* access */
export function access(permissions) {
	const userPermissions = user.pull('permissions');
	if (typeof permissions === 'string') {
		if (userPermissions.indexOf(permissions) > -1)
			return true;
		return false;
	}
	if (Array.isArray(permissions)) {
		const len = permissions.length;
		for (let i = 0; i < len; i++) {
			if (userPermissions.indexOf(permissions[i]) > -1)
				return true;
		}
	}
	return false;
}


/* updateFilters */
export function updateFilters(data) {
	if (data.hasOwnProperty('_filters')) {
		filters.pushAvailable(null, data._filters);
		filters.push({ '_update': false });
	}
}


/* updateBindings */
export function updateBindings(data) {
	if (data.hasOwnProperty('_bindings')) {
		bindings.push(data._bindings);
	}
}
